import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clone, equals } from 'ramda';
import TieredSelect from '../common/lookups/tieredSelect';
import entityComposition from '../common/classes/entityComposition';
import Loader from '../common/loader';
import SegmentedPicker from '../common/controls/segmentedPicker';
const _buildHierarchy = function buildHierarchy(list) {
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    id: null
  };
  if (list.length === 0) {
    // Done...
    return root;
  }
  const selection = [];
  const reducedList = [];
  // Check to see which nodes have the current root as a parent
  list.forEach(node => {
    if (node.parentID === root.id) {
      selection.push(node);
    } else {
      reducedList.push(node);
    }
  });

  // Attempt to add any child nodes
  const nodes = selection.map(node => _buildHierarchy(reducedList, node));
  return _objectSpread(_objectSpread({}, root), {}, {
    nodes
  });
};
const findNode = (node, tree) => {
  if (tree.id === node.id) {
    return tree;
  }
  if (!tree.nodes || tree.nodes.length === 0) {
    return null;
  }
  const foundChild = tree.nodes.find(treeChild => findNode(node, treeChild));
  return foundChild ? findNode(node, foundChild) : null;
};
class IssueItemFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleOnDemandCall = this.handleOnDemandCall.bind(this);
    this.buildTreeFromProps = this.buildTreeFromProps.bind(this);
    this.finishOnDemand = this.finishOnDemand.bind(this);
    this.handleOtherChange = this.handleOtherChange.bind(this);
    this.tree = {
      count: 0
    };
    this.state = {
      hideOthers: true
    };
    this.onDemand = null;
  }
  componentDidMount() {
    const _this$props$issueIssu = this.props.issueIssueItem.indexQuery,
      _this$props$issueIssu2 = _this$props$issueIssu === void 0 ? {} : _this$props$issueIssu,
      _this$props$issueIssu3 = _this$props$issueIssu2.hideOthers,
      hideOthers = _this$props$issueIssu3 === void 0 ? true : _this$props$issueIssu3;
    // Ensure that the show
    // other toggle represents what
    // is being shown in the list
    // when the component is remounted
    this.setState({
      hideOthers
    });
    this.loadIssueItems();
  }
  componentDidUpdate() {
    if (this.onDemand !== null) {
      this.finishOnDemand();
    }
  }
  getOptionsForSelections() {
    const _this$props = this.props,
      _this$props$selection = _this$props.selection,
      selection = _this$props$selection === void 0 ? [] : _this$props$selection,
      _this$props$issueIssu4 = _this$props.issueIssueItem.list,
      list = _this$props$issueIssu4 === void 0 ? [] : _this$props$issueIssu4;

    // array of ID objects
    const selections = selection.map(_ref => {
      let id = _ref.id;
      return list.find(item => id === item.id);
    }).filter(item => item !== undefined);
    return selections;
  }
  loadIssueItems() {
    let parentID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const _this$props2 = this.props,
      issueIssueItem = _this$props2.issueIssueItem,
      issueIssueItemActions = _this$props2.issueIssueItemActions,
      filters = _this$props2.filters;
    const hideOthers = this.state.hideOthers;
    const _clone = clone(issueIssueItem.indexQuery.filters),
      _clone$issueItem = _clone.issueItem,
      issueItem = _clone$issueItem === void 0 ? [] : _clone$issueItem,
      _clone$issueItemOther = _clone.issueItemOther,
      issueItemOther = _clone$issueItemOther === void 0 ? [] : _clone$issueItemOther;
    // Ensure the parentID is either null (root) or another node
    if (parentID !== undefined) {
      if (issueItem.every(_ref2 => {
        let id = _ref2.id;
        return id !== parentID;
      })) {
        issueItem.push({
          id: parentID
        });
      }
    }
    const newFilter = _objectSpread(_objectSpread({}, filters), {}, {
      issueItem,
      issueItemOther
    });
    // If filter has not changed, need to finishOnDemand since there will be no update from filter.
    // first time through, item will be undefined, so go dont finishOnDemand that time.
    if (parentID !== undefined && equals(newFilter, issueIssueItem.indexQuery.filters)) {
      if (this.onDemand !== null) {
        this.finishOnDemand();
      }
      return;
    }
    issueIssueItemActions.serverFilter(newFilter, _objectSpread(_objectSpread({}, issueIssueItem.indexQuery), {}, {
      hideOthers
    }));
  }
  finishOnDemand() {
    const issueIssueItem = this.props.issueIssueItem;
    if (issueIssueItem.loading || !this.onDemand) {
      return;
    }
    const nodeInTree = findNode(this.onDemand.option, this.tree);
    if (!nodeInTree) {
      return;
    }
    // Double check to ensure we have children to navigate to
    if (nodeInTree.nodes && nodeInTree.nodes.length !== 0) {
      this.onDemand.forwardCallback(nodeInTree);
    }
    this.onDemand.callback(nodeInTree);
    this.onDemand = null;
  }
  handleOnDemandCall(option, callback, forwardCallback) {
    if (option.childrenCount === 0) {
      callback(option);
      return;
    }
    this.onDemand = {
      option,
      callback,
      forwardCallback
    };
    this.loadIssueItems(option.id);
  }
  handleOtherChange(selection) {
    const hideOthers = !!selection;
    this.setState({
      hideOthers
    });
    const _this$props3 = this.props,
      issueIssueItem = _this$props3.issueIssueItem,
      issueIssueItemActions = _this$props3.issueIssueItemActions;
    issueIssueItemActions.serverFilter(issueIssueItem.indexQuery.filters, _objectSpread(_objectSpread({}, issueIssueItem.indexQuery), {}, {
      hideOthers
    }));
  }
  handleChange(values, value) {
    const _this$props4 = this.props,
      onChange = _this$props4.onChange,
      selection = _this$props4.selection;
    const children = selection.filter(child => child.id !== value.id);
    if (value.childrenCount === 0 || value.childrenCount === undefined) {
      if (children.length === selection.length) {
        children.push(value);
      }
      onChange(children);
    }
  }
  buildTreeFromProps() {
    const issueIssueItem = this.props.issueIssueItem;
    // @TODO https://www.pivotaltracker.com/story/show/167581523
    // The tree is reconstructed from scratch every time render is called with a different
    // set of objects.  Since the tree never gets smaller this can be optimized by just
    // appending new values to the tree instead of building it from scratch again
    const totalNodes = issueIssueItem.list.length;
    // Do not attempt to rebuild if nothing has changed
    if (this.tree.count === totalNodes) {
      return this.tree;
    }
    // const others = this.props.other.list.map(other => ({
    //   ...other,
    //   name: `Other: ${other.otherString}`,
    //   parentID: other.issueItemGroupID,
    // }));
    // const zipped = [...this.props.parent.list, ...children, ...others];
    const treeList = issueIssueItem.list;
    const tree = _buildHierarchy(treeList || []);
    tree.count = treeList.length;
    return tree;
  }
  render() {
    const _this$props5 = this.props,
      issueIssueItem = _this$props5.issueIssueItem,
      label = _this$props5.label,
      children = _this$props5.children,
      onBack = _this$props5.onBack;
    const hideOthers = this.state.hideOthers;
    if (!issueIssueItem.loading) {
      this.tree = this.buildTreeFromProps();
    }
    // flesh out selections to their full option properties.
    const selections = this.getOptionsForSelections();
    const nodes = this.tree.nodes || [];
    return /*#__PURE__*/React.createElement(TieredSelect, {
      handlePreSelect: this.handleOnDemandCall,
      label: label,
      data: nodes,
      entity: "IssueIssueItem",
      value: selections,
      onBack: onBack,
      autoForward: true,
      multi: true,
      onChange: this.handleChange
    }, children, /*#__PURE__*/React.createElement(SegmentedPicker, {
      names: ['Show Others', 'Hide Others'],
      values: [false, true],
      label: null,
      allowNull: false,
      hideLabel: true,
      onChange: this.handleOtherChange,
      value: hideOthers
    }), /*#__PURE__*/React.createElement(Loader, {
      loaded: !issueIssueItem.loading
    }));
  }
}
export { IssueItemFilter as TestIssueItemFilter };
IssueItemFilter.propTypes = {
  label: PropTypes.string.isRequired,
  selection: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
  onBack: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({}).isRequired,
  issueIssueItemActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  issueIssueItem: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool,
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    })
  }).isRequired
};
export default entityComposition(IssueItemFilter, ['issueIssueItem']);